import { render, staticRenderFns } from "./eComplaintHeader.vue?vue&type=template&id=6ab983b2"
import script from "./eComplaintHeader.vue?vue&type=script&lang=js"
export * from "./eComplaintHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports